module.exports = __webpack_public_path__ + "static/media/shoppingCart.75df6aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/shoppingCart.png
// module id = 41
// module chunks = 0